export default __webpack_public_path__ + "static/media/documents.af1eb1a0.png";